var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path !== '/')?_c('div',{staticClass:"tool-header"},[_c('router-link',{staticStyle:{"color":"#007bff","text-decoration":"none"},attrs:{"to":"/"}},[_c('h2',[_vm._v("快工具箱")])])],1):_vm._e(),_c('router-view'),_vm._m(0),_c('return-button')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("版权所有 © 2023 快工具箱 - 我向风而行 追寻自由的呼唤")])])
}]

export { render, staticRenderFns }